import SendPaytBySupplyArea from "@/pages/comp/supply/payt/payt_supply/common/send_payt_by_supply";

function SendPaytBySupplyPopup(props:any){
   let myProps={
    supply_seq_arr: {},
    refresh_data:(inData:any)=>{},
    closePopup:()=>{},
    ...props
  };
  
  return (
  <div>
    <SendPaytBySupplyArea
      supply_seq_arr={myProps.supply_seq_arr}
      refresh_data={myProps.refresh_data}
      is_show_close={true}
      close={myProps.closePopup}
    ></SendPaytBySupplyArea>
  </div>
  );
};
export default SendPaytBySupplyPopup;